import { useCallback, useEffect, useMemo, useRef } from "react";

/**
 * AbortController scope for data fetching: each new {@link begin} aborts the previous
 * in-flight request; unmount aborts the latest. Use {@link isCurrent} before applying
 * results so an aborted request does not clear loading or overwrite newer data.
 */
export function useLatestRequestController() {
  const currentRef = useRef(null);

  const begin = useCallback(() => {
    currentRef.current?.abort();
    const c = new AbortController();
    currentRef.current = c;
    return c;
  }, []);

  const isCurrent = useCallback((c) => currentRef.current === c, []);

  useEffect(
    () => () => {
      currentRef.current?.abort();
      currentRef.current = null;
    },
    [],
  );

  return useMemo(() => ({ begin, isCurrent }), [begin, isCurrent]);
}
